export default __webpack_public_path__ + "static/media/news38.36b5848d.jpg";